module.exports = __webpack_public_path__ + "images/ico.c9a001e6bddd9969c4e17fed4655ef4f.png";